module.exports = __webpack_public_path__ + "static/home-top-bg-230abdd8607eed9c5ee417710f84ca21.jpg";